export default {
    company: {
        name: "宜賓紙業"
    },
    nav: {
        home: "ホーム",
        about: "会社概要",
        products: "製品",
        contact: "お問い合わせ",
        sustainability: "持続可能性",
        technology: "技術革新"
    },
    banner: {
        title: "竹の雅 · 緑の未来",
        subtitle: "千年の製紙技術を継承し、竹パルプ製紙の新基準をリード"
    },
    products: {
        subtitle: "高品質な竹パルプ紙製品で多様なニーズに対応",
        description: "原紙から完成品まで、あらゆるニーズに対応する包括的な紙製品ソリューションを提供",
        viewDetails: "詳細を見る",
        categories: {
            title: "製品シリーズ",
            subtitle: "竹パルプ紙製品、グリーン消費の新トレンドをリード",
            livingPaper: "生活用紙原紙",
            livingPaperDesc: "生活用紙原紙シリーズ",
            foodPaper: "食品包装原紙",
            foodPaperDesc: "食品包装原紙シリーズ",
            finishedProducts: "生活用紙完成品シリーズ"
        },
        advantages: {
            title: "製品の強み",
            subtitle: "竹の力で生活を革新"
        },
        applications: {
            title: "応用分野",
            subtitle: "日常生活や様々な産業で幅広く活用"
        },
        items: {
            livingPaper: {
                title: "生活用紙原紙",
                description: "高品質な生活用紙原紙シリーズ"
            },
            foodPaper: {
                title: "食品包装原紙",
                description: "安全で環境に優しい食品包装原紙"
            },
            handTowel: {
                title: "ハンドタオルシリーズ",
                description: "吸水性が強く、破れにくい"
            },
            kitchenTissue: {
                title: "キッチンペーパーシリーズ",
                description: "吸水性が強く、破れにくい"
            },
            boxTissue: {
                title: "ボックスタオルシリーズ",
                description: "取り出しやすく、経済的"
            },
            rollPaper: {
                title: "ロールペーパーシリーズ",
                description: "柔らかく快適、吸水性が強い"
            },
            softTissue: {
                title: "ソフトタオルシリーズ",
                description: "柔らかく快適、取り出しやすい"
            },
            pocketTissue: {
                title: "ポケットティッシュ",
                description: "コンパクトで携帯に便利"
            },
            barTowel: {
                title: "バータオルシリーズ",
                description: "吸水性が強く、破れにくい"
            },
            smallRoll: {
                title: "スモールロールシリーズ",
                description: "コンパクトで使いやすい"
            }
        },
        cta: {
            title: "カスタム製品ソリューションが必要ですか？",
            description: "お客様のニーズに基づいて、専門的な竹パルプ紙製品のカスタマイズサービスを提供いたします",
            buttonText: "お問い合わせ"
        },
        detail: {
            features: '製品の特徴',
            contactUs: 'お問い合わせ',
            specifications: '製品仕様',
            usageScenarios: '使用シーン',
            relatedProducts: '関連製品',
            cta: {
                title: '製品情報が必要ですか？',
                description: '製品コンサルタントが専門的なアドバイスとカスタマイズソリューションを提供いたします',
                buttonText: 'お問い合わせ'
            }
        }
    },
    advantages: {
        title: "当社の強み",
        subtitle: "竹パルプ製紙、環境に優しい技術、卓越した品質",
        items: {
            experience: {
                title: "豊富な業界経験",
                description: "80年の技術蓄積、完全な製紙産業チェーン、グリーン低炭素バイオベース材料転換のための堅固な技術サポートを提供。"
            },
            production: {
                title: "成熟した生産システム",
                description: "完全な生産設備と自動化された生産ライン、顧客のニーズに迅速に対応し、低コスト・高効率の大量生産を実現。"
            },
            innovation: {
                title: "産学連携によるイノベーション",
                description: "大学や研究機関との共同研究所を設立し、低炭素プロセスと再生可能材料の研究開発に注力、バイオベース材料などの先端技術の産業化を加速。"
            },
            certification: {
                title: "完全なグリーン認証",
                description: "原料調達から製品製造まで、FSC、医療グレード製品、衛生安全製品などの認証を取得し、製品競争力を向上。"
            }
        }
    },
    footer: {
        contact: "お問い合わせ",
        address: "住所：四川省宜賓市",
        phone: "電話：0831-12345678",
        email: "メール：info@yibinpaper.com",
        quickLinks: "クイックリンク",
        moreInfo: "詳細情報",
        news: "ニュース",
        careers: "採用情報",
        followUs: "フォロー",
        wechat: "WeChat公式アカウント：宜賓紙業",
        rights: "著作権所有",
        slogan: "竹パルプ製紙、グリーンイノベーション"
    },
    about: {
        companyProfile: "会社概要",
        established: "1944年に設立",
        formerName: "旧名「中国製紙工場」",
        firstNewsprint: "中国初の機械製新聞紙の誕生地",
        listed: "1997年上海証券取引所上場（証券コード：600793）",
        firstListed: "中国製紙業界初の上場企業",
        firstYibinListed: "宜賓市初の上場企業",
        wuliangyeSubsidiary: "2018年1月に五糧液グループの子会社となる",
        capacity: "生産能力",
        mainCapacity: "本社工場のパルプ・紙総生産能力54万トン/年",
        managedCapacity: "管理会社のパルプ・紙総生産能力12万トン/年",
        newMaterialCapacity: "新素材段ボール箱生産能力1億平方メートル/年",
        bambooMoldingCapacity: "新素材竹パルプ成形生産能力6,600トン/年",
        celluloseCapacity: "酢酸セルロース生産能力3万トン/年",
        historyTitle: "発展の歩み",
        historySubtitle: "70年以上の歩み、竹パルプ製紙ブランドの確立",
        historyItems: {
            "1944": "中国製紙工場設立、中国製紙工業の幕開け",
            "1945": "中国初の100%機械木パルプ新聞紙の生産に成功",
            "1950": "「中国製紙工場」から「宜賓製紙工場」に改称",
            "1961": "朱德委員長の視察",
            "1966": "彭徳懐元帥の視察",
            "1988": "株式制改革の試行、「宜賓紙業株式会社」設立",
            "1997": "上海証券取引所に上場",
            "2012": "宜賓紙業の移転工事起工式",
            "2015": "新工場食品包装紙生産ライン完成・稼働開始",
            "2018_1": "新工場生活用紙生産ライン完成・稼働開始",
            "2018_2": "五糧液グループの子会社となる",
            "2025": "伝統的な製紙産業からグリーンカーボン特殊バイオベース材料産業総合グループへの戦略的発展の道を歩む"
        },
        futureDevelopment: "将来の発展",
        future: {
            point1: "発展目標への総合的焦点",
            point2: "竹資源の特徴と優位性の最大活用",
            point3: "特殊化、ハイテク、高付加価値事業への転換加速",
            point4: "紙製品分野における世界クラスの専門企業の育成"
        },
        coreValues: "企業理念",
        coreValuesSubtitle: "竹を骨とし、紙を魂とし、グリーンイノベーションで発展を推進",
        values: {
            mission: "企業ミッション",
            missionLine1: "新規生物材料を基盤とし",
            missionLine2: "グリーンカーボンの美しい世界を創造",
            vision: "企業ビジョン",
            visionLine1: "グリーンカーボン特殊バイオベース",
            visionLine2: "材料産業総合グループの構築",
            coreValues: "コアバリュー",
            coreValuesLine1: "品質第一、イノベーション推進",
            coreValuesLine2: "グリーン発展、共創共栄",
            philosophy: "経営理念",
            philosophyLine1: "顧客中心",
            philosophyLine2: "品質を基盤とし、イノベーションを原動力とする"
        },
        certificationsTitle: "認証",
        certificationsSubtitle: "品質保証、業界認証",
        certificationItems: {
            fsc: "国際森林認証、責任ある管理の森林資源からの原料調達",
            iso9001: "国際品質マネジメントシステム認証",
            iso14001: "国際環境マネジメントシステム認証",
            medical: "医療グレード製品認証",
            medicalDesc: "医療グレード製品認証書",
            antibacterial: "抗菌衛生認証",
            antibacterialDesc: "抗菌衛生認証書",
            safety: "衛生安全製品認証",
            safetyDesc: "衛生安全製品認証書"
        },
        honorsTitle: "会社の栄誉",
        honorsSubtitle: "品質保証、業界認証",
        honorItems: {
            greenFactory: "国家グリーンファクトリー",
            greenFactoryDesc: "工業情報化部認定のグリーン製造ベンチマーク企業",
            forestryLeader: "国家林業重点リーディング企業",
            forestryLeaderDesc: "国家林業草原局認定の重点リーディング企業",
            agriculturalProduct: "中国優秀農産物企業",
            agriculturalProductDesc: "中国優秀農産物企業ブランド",
            lightIndustry: "全国軽工業先進集団",
            lightIndustryDesc: "全国軽工業先進集団",
            bambooExpo: "2025竹博覧会優秀組織賞",
            bambooExpoDesc: "2025竹博覧会優秀組織賞",
            engineeringCenter: "製紙技術研究センター",
            engineeringCenterDesc: "四川省竹パルプ製紙技術研究センター"
        },
        productHonorsTitle: "製品の栄誉",
        productHonorsSubtitle: "品質保証、業界認証",
        productHonorItems: {
            industryExcellence: "業界優秀製品",
            neZhaExcellence: "哪吒シリーズが2025年中国生活用紙業界優秀製品を受賞",
            moDiKaExcellence: "莫迪卡シリーズが2025年中国生活用紙業界優秀製品を受賞",
            bambooExpoGold: "竹博覧会金賞",
            moDiKaGold: "莫迪卡シリーズが2025年竹博覧会金賞を受賞",
            shanghaiExpoGold: "上海国際竹博覧会金賞",
            jinZhuGold: "金竹ナチュラルシリーズが2020年上海国際竹博覧会金賞を受賞",
            quanZhuGold: "全竹包装原紙が2018年上海国際竹博覧会金賞を受賞",
            westernExpoGold: "中国西部林業産業博覧会金賞",
            jinZhuWesternGold: "金竹ナチュラルシリーズが2018年第一回中国西部林業産業博覧会金賞を受賞"
        },
        cta: {
            title: "宜賓紙業と共に、グリーンな未来を創造しましょう",
            description: "竹パルプ製紙産業の持続可能な発展を共に推進することを楽しみにしています",
            buttonText: "お問い合わせ"
        }
    },
    technology: {
        title: '技術革新',
        subtitle: '技術リーダーシップ、グリーンイノベーション、新産業基準の創出',
        innovation: {
            title: 'イノベーション主導の発展',
            subtitle: '技術リーダーシップ、グリーンイノベーション、新産業基準の創出',
            management: {
                title: '効率的なイノベーション管理システム',
                content: '宜賓紙業は常に技術革新を企業発展の核心的推進力として位置づけています。会社は戦略開発委員会を設立し、研究開発、生産、市場部門を調整し、「本社技術研究開発部門＋生産基地」というイノベーションアーキテクチャを構築し、柔軟なインセンティブメカニズムにより、技術革新から産業化までの効率的な実施を確保しています。'
            },
            team: {
                title: '専門チームによる技術的ブレークスルー',
                content: '省級イノベーションプラットフォームと研究開発イノベーションチームを拠点に、複数の著名な大学や研究機関と緊密な協力関係を維持し、低炭素パルプ、バイオベース材料などの先端分野に焦点を当てて研究開発プロジェクトを実施し、企業のイノベーションと発展に強力な原動力を提供しています。'
            },
            results: {
                title: 'イノベーション成果による産業アップグレード',
                content: '竹パルプと製紙のコア技術の全チェーンを掌握し、技術革新を通じてグリーンパルプ、クリーン生産、総合資源利用において継続的なブレークスルーを実現し、企業のグリーン低炭素バイオベース材料産業への転換とアップグレードをリードしています。'
            }
        },
        core: {
            title: 'コア技術',
            subtitle: '技術リーダーシップ、グリーンイノベーション',
            tabs: {
                pulping: '竹材パルプ技術',
                bleaching: '循環経済コア技術',
                papermaking: 'グリーン製品イノベーション技術'
            },
            items: {
                pulping: {
                    details: [
                        {
                            title: '竹材前処理技術システム',
                            content: '高密度・高シリコン含有量の竹材処理の課題を突破し、均一浸漬技術を開発、エネルギー消費を10%以上削減。'
                        },
                        {
                            title: '低炭素クリーンパルプ技術',
                            content: '"深度脱リグニン-ECF漂白"連用プロセスにより、AOX排出量が国家基準より30%以上低減；"嫌気性+好気性+フェントン"水処理技術の統合により、COD排出量が国家基準より50%以上低減。'
                        }
                    ]
                },
                bleaching: {
                    details: [
                        {
                            title: '竹材全成分利用技術',
                            content: '竹セルロースをパルプ・製紙に使用；黒液リグニンを燃焼して熱回収、トン当たり350kWhの発電が可能；パルプ廃棄物を生物肥料に変換して自然に還元。'
                        }
                    ]
                },
                papermaking: {
                    details: [
                        {
                            title: '機能性竹繊維製品',
                            content: '竹繊維強化技術により、包装紙の引張・折り曲げ強度指標を50%以上向上させ、製品性能を向上；竹材の天然抗菌成分を活用した自己抗菌生活用紙製品を開発し、同等条件下で抗菌効率を90%以上向上。'
                        },
                        {
                            title: 'バイオベース新素材',
                            content: '竹繊維製品でプラスチック製品を代替し、カーボンフットプリントを60%削減。'
                        }
                    ]
                }
            }
        },
        research: {
            title: '研究開発センター',
            subtitle: '研究開発に焦点を当て、価値を創造',
            imageAlt: '宜賓紙業研究開発センター',
            center: {
                title: '国家企業技術センター',
                content: '2003年に設立された研究開発センターは、会社の技術革新の中核部門であり、パルプと製紙技術の研究、新製品開発、生産プロセスの最適化に専念しています。2009年と2023年に省級企業技術センターとして認定されました。人材、技術、資源を統合し、産業発展の動向に焦点を当て、科学技術成果の転化を促進し、企業に核心的競争力を提供しています。'
            },
            cooperation: {
                title: '共同研究開発',
                content: 'センターは四川農業大学、華南理工大学、北京林業大学、南京林業大学、中国林業科学研究院などの大学や研究機関と長期的な協力関係を確立し、国家および省レベルの研究プロジェクトを共同で実施し、産学研の深い融合を促進しています。'
            }
        },
        patents: {
            title: '特許と成果',
            subtitle: '技術の蓄積、産業のリーダーシップ',
            authorized: {
                title: '取得特許',
                items: [
                    '精製混合竹パルプとその製造方法および製紙への応用',
                    '精製竹パルプとその製造方法および製紙への応用',
                    'アルカリ回収炉用黒液ガン',
                    '繊維スクリーニング装置'
                ]
            },
            projects: {
                title: '研究プロジェクト',
                items: [
                    '高嵩高強度竹パルプクリーンエネルギー製造と高強度包装ボード技術の研究',
                    '竹化学パルプ精製と高級ティッシュペーパー技術の研究',
                    '竹ベースパルプ深加工技術の研究開発',
                    '高品質竹ベースセルロース繊維の研究開発',
                    '機能性リグニン高付加価値製品の研究開発'
                ]
            },
            awards: {
                title: '技術賞',
                items: [
                    '四川省科学技術進歩一等賞'
                ]
            },
            papers: {
                title: '研究論文',
                items: [
                    'カチオン分散ロジンエマルション中の総ロジンと硫酸アルミニウム含有量の測定',
                    '竹化学機械パルプによる天然食品段ボールの試作',
                    '全竹DDS蒸解における蒸解添加剤の応用',
                    '繊維分画による溶解パルプ生産における竹繊維資源の効率的利用のための新規プロセス：実験室研究と工場試験',
                    'リグニン価値化のための光触媒予酸化-超音波キャビテーション分解のタンデム戦略'
                ]
            }
        },
        projects: {
            title: 'イノベーションプロジェクト',
            subtitle: '将来の産業発展をリード',
            items: [
                {
                    title: '四川竹産業チェーン重要技術統合とデモンストレーション工場',
                    period: '2019-2022',
                    cooperation: '四川農業大学',
                    desc: '竹資源チェーンと産業チェーンを統合し、竹産業の発展を促進。'
                },
                {
                    title: '宜賓森林竹産業ハイテクイノベーションプラットフォーム構築とデモンストレーション',
                    period: '2019-2022',
                    cooperation: '華南理工大学',
                    desc: '低硫黄竹蒸解技術と黒液高付加価値利用技術のブレークスルー。'
                },
                {
                    title: '竹ベースパルプ深加工技術の研究開発',
                    period: '2022-2024',
                    cooperation: '中国林業科学研究院',
                    desc: '高収率竹パルプ製造の重要技術を突破し、産業化を実施して原料輸入代替を実現。'
                },
                {
                    title: '機能性リグニン高付加価値製品の研究開発',
                    period: '2022-2024',
                    cooperation: '北京林業大学',
                    desc: '竹パルプ製造黒液からリグニン成分を抽出して副産物を調製し、黒液高付加価値利用経路を突破。'
                },
                {
                    title: '竹パルプと製紙統合重要技術の研究',
                    period: '2023-2028',
                    cooperation: '中国林業科学研究院',
                    desc: '効率的な均一浸漬軟化、精密解離省エネ精製、アルカリ過酸化水素活性化漂白などの重要技術。'
                },
                {
                    title: 'スマート竹産業重要技術研究と統合デモンストレーション',
                    period: '2024-2027',
                    cooperation: '南京林業大学',
                    desc: '竹パルプと製紙企業のクリーン製造と総合資源利用における重要技術的課題の研究を実施。'
                }
            ]
        },
        cta: {
            title: '竹パルプと製紙の未来を共に探求',
            subtitle: '竹パルプと製紙技術革新に興味のあるパートナーの皆様のご連絡をお待ちしております。産業発展を共に推進しましょう',
            button: 'お問い合わせ'
        }
    },
    home: {
        advantages: {
            title: "当社の強み",
            subtitle: "竹パルプ製紙、環境に優しい技術、卓越した品質",
            items: {
                experience: {
                    title: "豊富な業界経験",
                    description: "80年の技術蓄積、完全な製紙産業チェーン、グリーン低炭素バイオベース材料転換のための堅固な技術サポートを提供。"
                },
                production: {
                    title: "成熟した生産システム",
                    description: "完全な生産設備と自動化された生産ライン、顧客のニーズに迅速に対応し、低コスト・高効率の大量生産を実現。"
                },
                innovation: {
                    title: "産学連携によるイノベーション",
                    description: "大学や研究機関との共同研究所を設立し、低炭素プロセスと再生可能材料の研究開発に注力、バイオベース材料などの先端技術の産業化を加速。"
                },
                certification: {
                    title: "完全なグリーン認証",
                    description: "原料調達から製品製造まで、FSC、医療グレード製品、衛生安全製品などの認証を取得し、製品競争力を向上。"
                }
            }
        },
        products: {
            title: "主な製品",
            subtitle: "高品質な竹パルプ紙製品で多様なニーズに対応",
            items: {
                bambooPulp: {
                    title: "バージン竹パルプ",
                    description: "厳選された竹種、上質な竹繊維",
                    alt: "竹パルプ"
                },
                packagingPaper: {
                    title: "バージン竹パルプ包装用紙",
                    description: "高強度、優れた耐折性、高い清浄度",
                    alt: "包装用紙"
                },
                culturalPaper: {
                    title: "バージン竹パルプ文化用紙",
                    description: "滑らかで繊細、書き心地・印刷性に優れる",
                    alt: "文化用紙"
                },
                livingPaper: {
                    title: "バージン竹パルプ生活原紙",
                    description: "濡れても強い、環境にやさしい",
                    alt: "生活原紙"
                },
                finishedPaper: {
                    title: "バージン竹パルプ生活成品紙",
                    description: "柔らかく快適、健康的で抗菌",
                    alt: "生活成品紙"
                },
                fiberMaterial: {
                    title: "繊維素材",
                    description: "多機能で様々な特殊ニーズに対応",
                    alt: "繊維素材"
                },
                learnMore: "詳細を見る"
            },
        },
        about: {
            title: "宜賓紙業について",
            description1: "1944年に設立された宜賓紙業株式会社は、中国をリードする竹パルプ紙メーカーであり、竹パルプ製紙の研究と生産に注力しています。",
            description2: "四川省宜賓市に位置し、豊富な竹資源と先進的な生産設備を有し、年間50万トン以上の高品質竹パルプ紙の生産能力を誇ります。",
            description3: "技術革新とグリーン生産を通じて、高品質で環境に優しい紙製品を提供し、製紙業界の持続可能な発展を推進しています。",
            learnMore: "詳細を見る"
        },
        sustainability: {
            title: "持続可能な発展",
            subtitle: "竹パルプ製紙、グリーンサイクル",
            items: {
                renewable: {
                    title: "再生可能な竹資源",
                    description: "竹は3-5年で収穫可能で、成長が早く、製紙の理想的な再生可能原料です"
                },
                carbon: {
                    title: "カーボンシンク貢献",
                    description: "竹林は同等面積の森林よりも多くのCO₂を吸収し、気候変動の緩和に効果的です"
                },
                clean: {
                    title: "クリーン生産",
                    description: "閉鎖循環型生産プロセスを採用し、廃水処理と再利用により、省エネ・排出削減を実現"
                },
                rural: {
                    title: "農村振興",
                    description: "竹農家の収入増加を促進し、地域経済発展を後押し、生態系と経済の両立を実現"
                }
            }
        },
        cta: {
            title: "グリーンな未来のために共に歩みましょう",
            description: "高品質な竹パルプ紙製品と専門的なサービスをご提供いたします",
            buttonText: "お問い合わせ"
        }
    },
    sustainability: {
        title: "持続可能な発展",
        subtitle: "竹パルプ製紙、グリーンサイクル",
        vision: {
            title: "持続可能な発展ビジョン",
            content: "竹パルプ製紙産業の持続可能な発展を推進し、グリーンイノベーションで未来を創造",
            intro1: "宜賓紙業は、竹パルプ製紙産業の持続可能な発展を推進することを使命としています。",
            intro2: "私たちは、竹資源の特性を活かし、クリーン生産技術を革新し、循環経済モデルを構築することで、",
            intro3: "環境保護と経済発展の調和を実現し、グリーンな未来を共に創造します。",
            items: {
                circular: {
                    title: "循環経済",
                    content: "竹資源の特性を活かし、クリーン生産技術を革新し、循環経済モデルを構築"
                },
                innovation: {
                    title: "グリーンイノベーション",
                    content: "持続可能な技術革新を通じて、環境に優しい製品とサービスを提供"
                },
                rural: {
                    title: "農村振興",
                    content: "竹産業の発展を通じて、農村地域の経済発展を促進し、農家の収入を増加"
                },
                cooperation: {
                    title: "協力共創",
                    content: "政府、企業、研究機関と協力し、持続可能な発展のエコシステムを構築"
                }
            },
            commitment: {
                title: "私たちの約束",
                content: "宜賓紙業は、持続可能な発展を企業の核心的価値として位置づけ、環境保護、社会責任、経済発展の調和を追求します。"
            }
        },
        cleanProduction: {
            title: "クリーン生産",
            subtitle: "環境に優しい生産プロセス、持続可能な発展",
            description: "宜賓紙業は、クリーン生産を企業の核心的競争力として位置づけ、生産プロセスの各段階で環境保護と資源節約を実践しています。",
            items: {
                raw: {
                    title: "原料調達",
                    subtitle: "持続可能な竹資源の利用",
                    points: [
                        "FSC認証を取得した持続可能な竹資源の調達",
                        "地元の竹農家との直接取引による透明性の確保",
                        "竹資源の再生可能な特性を活かした環境配慮型調達"
                    ]
                },
                process: {
                    title: "生産プロセス",
                    subtitle: "クリーン生産技術の革新",
                    points: [
                        "閉鎖循環型生産システムの採用",
                        "省エネ・排出削減技術の導入",
                        "廃水・廃棄物の資源化利用"
                    ]
                },
                recycle: {
                    title: "資源循環",
                    subtitle: "廃棄物の資源化利用",
                    points: [
                        "生産過程での副産物の有効利用",
                        "廃水処理と再利用システムの構築",
                        "エネルギー効率の最適化"
                    ]
                },
                product: {
                    title: "製品設計",
                    subtitle: "環境配慮型製品の開発",
                    points: [
                        "100%生分解可能な竹パルプ製品の開発",
                        "環境に優しい包装材料の使用",
                        "製品ライフサイクル全体での環境影響の最小化"
                    ]
                }
            }
        },
        circularEconomy: {
            title: "循環経済",
            subtitle: "資源の効率的利用、持続可能な発展",
            imageAlt: "循環経済モデル",
            intro: {
                title: "循環経済モデル",
                content: "宜賓紙業は、竹資源の特性を活かし、循環経済モデルを構築し、資源の効率的利用と環境保護を実現しています。"
            },
            items: {
                source: {
                    title: "原料段階",
                    points: [
                        "持続可能な竹資源の管理と利用",
                        "竹農家との直接取引による透明性の確保",
                        "竹資源の再生可能な特性を活かした環境配慮型調達"
                    ]
                },
                core: {
                    title: "生産段階",
                    points: [
                        "クリーン生産技術の革新と導入",
                        "エネルギー効率の最適化",
                        "廃水・廃棄物の資源化利用"
                    ]
                },
                upgrade: {
                    title: "製品段階",
                    points: [
                        "環境配慮型製品の開発と設計",
                        "製品ライフサイクル全体での環境影響の最小化",
                        "リサイクル可能な包装材料の使用"
                    ]
                }
            },
            vision: {
                title: "将来の展望",
                content: "宜賓紙業は、循環経済モデルをさらに発展させ、竹パルプ製紙産業の持続可能な発展をリードしていきます。"
            }
        },
        socialResponsibility: {
            title: "社会的責任",
            subtitle: "潤いを与え、善を広める",
            tabs: {
                community: "コミュニティ発展",
                farmers: "農家収入向上",
                education: "人材育成",
                biodiversity: "環境配慮"
            },
            community: {
                title: "農村振興計画",
                description: "宜賓紙業は国家の農村振興戦略に積極的に呼応し、「企業＋協同組合＋農家」モデルを通じて周辺農村の竹産業発展を牽引し、農村経済の活力を高めています。",
                items: {
                    village: {
                        title: "村支援",
                        content: "当社は翠屏区永興鎮獅子村に2名の党員幹部を第一書記として、江安県陽春鎮興旺村に1名の党員幹部を駐村ワークチーム員として派遣しています。"
                    },
                    manager: {
                        title: "集団経済職業マネージャー",
                        content1: "2名の中核人材を村に派遣し、「職業マネージャー」として村財政管理、制度整備、市場開拓、製品販売、経営人材育成などを担当。",
                        content2: "村集団経済の標準化、市場化、専門化レベルの向上を支援しています。"
                    },
                    project: {
                        title: "興文県大河ミャオ族郷産業発展協力ウィンウィン一対一プロジェクト",
                        content: "『宜賓市企業民族郷協力ウィンウィン一対一メカニズム運用方案』の要件に基づき、当社は興文県大河ミャオ族郷と連携し、竹原料販売の課題を解決しています。"
                    }
                }
            },
            farmers: {
                title: "農家収入向上プロジェクト",
                description: "地元の竹農家と安定した協力関係を築き、直接調達、スマート機器投資、科学的育種の推進などを通じて、農家の収入増加と共に豊かになることを支援しています。",
                imageAlt: "農家収入向上プロジェクト",
                items: {
                    direct: {
                        title: "直接調達で中間業者排除、農家利益を保護",
                        content1: "従来の買付モデルを打破し、「企業＋専業協同組合集荷場＋農家」「企業＋自社集荷場＋農家」など多様な直接調達モデルを構築。",
                        content2: "一次・二次産業の深い連携を強化し、中間業者を排除、各工程のコスト潜在力を掘り起こし、原料供給を確保し、農家の竹販売を便利にし、竹価格を安定させ、農家の利益を守ります。"
                    },
                    tech: {
                        title: "技術力で産業高度化、農家収入アップ",
                        content1: "スマート機器への投資を強化し、竹の伐採・運搬に関する機械の研究開発を推進。",
                        content2: "竹の伐採・運搬効率を全面的に向上させ、労働力を解放し、伐採コストを削減、技術の恩恵を農家と共有し収入増加を実現。",
                        content3: "科学的な育種・栽培・管理のデモンストレーションで高収量竹林を実現。",
                        content4: "農家に科学的な栽培を指導し、栽培・管理コストを削減、単位面積あたりの収量を増やし、農家の竹栽培収入を増加させます。"
                    },
                    value: {
                        title: "付加価値協力で販路拡大、総合収益向上",
                        content1: "多様な協力モデルを積極的に模索し、竹林の「非木材収益」を活性化、第三者機関と連携した竹林カーボンクレジット取引を試行し、管理成績に応じて農家に追加配当を実施。",
                        content2: "同時に林下栽培・養殖の発展を指導し、竹林の総合収益を向上。林下経済とカーボン経営を組み合わせ、竹林の炭素固定能力を高め、農家収入を増やし、「生態＋経済」の両立を実現します。"
                    }
                }
            },
            education: {
                title: "竹材人材育成計画",
                description: "人材は発展を牽引するコアエンジンです。当社は人材育成を重視し、多様な人材育成メカニズムを構築し、業界の未来を担う人材を育成しています。",
                imageAlt: "人材育成プロジェクト",
                items: {
                    mechanism: {
                        title: "多様な人材育成メカニズム",
                        content: "「師弟制」、後継人材プール、ジョブローテーション、カスタマイズ研修など多様な仕組みで、従業員が新人から業界エリートへ成長できるよう支援します。"
                    },
                    path: {
                        title: "発展パスの充実",
                        content: "昇進ルートや多様なキャリアパスを継続的に整備し、各メンバーが得意分野で輝き、会社と共に成長できる環境を提供します。"
                    }
                }
            },
            biodiversity: {
                title: "グリーンファクトリー計画",
                description: "国家の「ダブルカーボン」目標に積極的に呼応し、持続可能な発展を戦略の重点とし、環境マネジメントシステムを継続的に最適化しています。",
                imageAlt: "環境配慮プロジェクト",
                items: {
                    policy: {
                        title: "『竹で木材代替』『竹でプラスチック代替』",
                        content: "政府の『竹で木材代替』『竹でプラスチック代替』政策に積極的に呼応し、生産による自然資源への影響を低減し、低炭素経済への移行を推進、経済効果と環境効果の両立を実現します。"
                    },
                    factory: {
                        title: "グリーンファクトリー",
                        content: "FSCFM/CoC森林認証を取得し、国家級『グリーンファクトリー』企業、四川省『クリーン生産』企業に認定、製品は『四川省省エネ環境保護ブランド優秀製品賞』を受賞しています。"
                    }
                }
            }
        },
        report: {
            title: "持続可能な発展レポート",
            subtitle: "透明性、真実性、包括的な持続可能な発展情報の開示",
            download: 'レポートをダウンロード',
            items: {
                '2024': {
                    title: '2024年サステナビリティレポート',
                    date: '発行日：2024年4月',
                    imageAlt: '2024年サステナビリティレポート'
                },
                '2023': {
                    title: '2023年サステナビリティレポート',
                    date: '発行日：2023年4月',
                    imageAlt: '2023年サステナビリティレポート'
                }
            }
        },
        cta: {
            title: "グリーンな未来のために共に歩みましょう",
            description: "持続可能な発展に興味のあるパートナーの皆様のご連絡をお待ちしております",
            buttonText: "お問い合わせ"
        }
    },
    report: {
        title: '持続可能な発展レポート',
        subtitle: '透明性、真実性、包括的な持続可能な発展情報の開示'
    },
    contact: {
        banner: {
            title: 'お問い合わせ',
            subtitle: 'お気軽にご連絡ください'
        },
        contactInfo: {
            title: '連絡先',
            subtitle: 'お気軽にご連絡ください',
            address: {
                title: '会社住所',
                content: '四川省宜賓市南渓区裴石軽工業園区',
                postcode: '郵便番号：644100'
            },
            phone: {
                title: '電話番号',
                main: '代表：0831-3309663',
                service: 'カスタマーサービス：0831-3309689'
            },
            email: {
                title: 'メールアドレス',
                service: 'カスタマーサービス：ybzy@yb-zy.com',
                inquiry: '製品お問い合わせ：ybzy@yb-zy.com'
            },
            workingHours: {
                title: '営業時間',
                weekday: '月曜日～金曜日：9:00 - 17:30',
                holiday: '祝日休業'
            }
        },
        inquiry: {
            title: 'オンラインお問い合わせ',
            subtitle: '以下のフォームにご記入ください。折り返しご連絡いたします',
            form: {
                name: 'お名前',
                company: '会社名',
                email: 'メールアドレス',
                phone: '電話番号',
                subject: 'お問い合わせ内容',
                subjectPlaceholder: 'お問い合わせ内容を選択してください',
                subjects: {
                    product: '製品について',
                    price: '価格について',
                    technical: '技術サポート',
                    cooperation: 'ビジネス提携',
                    other: 'その他'
                },
                message: 'お問い合わせ内容',
                submit: '送信',
                submitting: '送信中...'
            },
            sales: {
                title: '営業サービス',
                domestic: '国内営業部',
                international: '国際営業部',
                email: '営業メール'
            },
            afterSales: {
                title: 'アフターサービス',
                hotline: 'サービスホットライン',
                technical: '技術サポート',
                email: 'サービスメール'
            },
            social: {
                title: 'SNS',
                wechat: '公式WeChat',
                weibo: '公式Weibo',
                linkedin: 'LinkedIn'
            }
        },
        location: {
            title: 'アクセス',
            subtitle: 'ご来社をお待ちしております',
            mapAlt: '宜賓紙業株式会社の地図',
            transport: {
                public: {
                    title: '公共交通機関',
                    content: 'バス路線：15番、27番、36番バスで「紙業公司」駅下車'
                },
                driving: {
                    title: '車でのアクセス',
                    content: '「宜賓紙業株式会社」までナビゲーションをご利用ください。来客用駐車場がございます'
                },
                airport: {
                    title: '空港からのアクセス',
                    content: '宜賓五糧液空港から約30キロメートル、空港バスまたはタクシーでお越しください'
                }
            }
        },
        offices: {
            title: 'グローバルオフィス',
            subtitle: '国際的なサービスネットワーク',
            china: {
                title: '中国本社',
                flagAlt: '中国国旗',
                address: '四川省宜賓市翠屏区岷江西路159号',
                phone: '電話：0831-12345678'
            },
            usa: {
                title: '北米事務所',
                flagAlt: 'アメリカ国旗',
                address: 'アメリカ合衆国カリフォルニア州ロサンゼルス市オーク通り2588号',
                phone: '電話：+1-213-888-9999'
            },
            japan: {
                title: '日本事務所',
                flagAlt: '日本国旗',
                address: '東京都千代田区丸の内1-2-3',
                phone: '電話：+81-3-1234-5678'
            },
            europe: {
                title: 'ヨーロッパ事務所',
                flagAlt: 'ドイツ国旗',
                address: 'ドイツハンブルク市ハンザ通り456号',
                phone: '電話：+49-40-8765-4321'
            },
            singapore: {
                title: '東南アジア事務所',
                flagAlt: 'シンガポール国旗',
                address: 'シンガポールラッフルズクエイ10号',
                phone: '電話：+65-6789-0123'
            }
        },
        faq: {
            title: 'よくある質問',
            subtitle: 'お問い合わせの多い質問にお答えします'
        },
        cta: {
            title: 'お気軽にご連絡ください',
            description: 'ご質問やご要望がございましたら、お気軽にお問い合わせください',
            buttonText: 'お問い合わせ'
        }
    }
} 